import React from 'react';

const OdontogramaInfo = () => {
    return (
        <div>
            <ul className="list-inline">
                <li className="list-inline-item">
                    <svg viewBox="0 0 10.78 6" style={{width: "16px", height: "16px", verticalAlign: "middle", margin: "0 4px 0 5px"}}>
                        <g style={{transform: "translateY(-1px)"}}>
                            <rect y="4.79" width="10.78" height="1.81" fill="#bad636"></rect>
                            <polygon points="5.39 0 10.78 3.9 0 3.9 5.39 0" fill="#bad636"></polygon>
                        </g>
                    </svg>
                    <small>Atache</small>
                </li>
                <li className="list-inline-item">
                    <svg viewBox="0 0 10 10" style={{width: "16px", height: "16px", verticalAlign: "middle", margin: "0 4px 0 5px"}}>
                        <g style={{transform: "scale(0.7)"}}>
                            <path
                                d="M7.14,0a7.14,7.14,0,1,0,7.14,7.14A7.14,7.14,0,0,0,7.14,0Zm0,11.31a4.17,4.17,0,1,1,4.17-4.17A4.17,4.17,0,0,1,7.14,11.31Z"
                                fill="#bad636"></path>
                        </g>
                    </svg>
                    <small>Botón</small>
                </li>
                <li className="list-inline-item">
                    <svg viewBox="0 0 10.78 6" style={{width: "16px", height: "16px", verticalAlign: "middle", margin: "0 4px 0 5px"}}>
                        <g style={{transform: "scale(0.65)translateY(-2px)"}}>
                            <polygon
                                points="13.95 3.85 10.1 0 6.97 3.13 3.85 0 0 3.85 3.13 6.97 0 10.1 3.85 13.95 6.97 10.82 10.1 13.95 13.95 10.1 10.82 6.97 13.95 3.85"
                                fill="#bad636"></polygon>
                        </g>
                    </svg>
                    <small>Elástico</small>
                </li>
                <li className="list-inline-item">
                    <svg viewBox="0 0 10.78 6" style={{width: "16px", height: "16px", verticalAlign: "middle", margin: "0 4px 0 5px"}}>
                        <g style={{transform: "scale(0.7)translateY(-4px)"}}>
                            <rect y="4.79" width="14.29" height="5.1" fill="#bad636"></rect>
                        </g>
                    </svg>
                    <small>Potenciador de torque</small>
                </li>
            </ul>
        </div>
    );
}
export default OdontogramaInfo;


// WEBPACK FOOTER //
// ./resources/assets/js/components/common/OdontogramaInfo.jsx